import { dasModal } from "../modal_v2.js";
import { identityService } from "./identityService_v2.js";
import { colors } from "../colors_v2.js";
import { profile } from "./profile_v2.js";
import { eventHub } from "../eventHub_v2.js";
import {
  loadingTextHTML,
  fillLoadedText,
  currentPasswordSplainerHTML,
  renderCurrentPasswordSplainer,
} from "./accountDetailsUI_v2.js";

const render = async () => {
  // The identity token doesn't carry the email. The pop-up opens right away
  // with a placeholder, then fills it in from getMyAccount.
  const html = `
    <div class="popUpHead">Change Email</div>
    <div class="center">Current Email is: ${loadingTextHTML("currentEmail")}</div><br>
    <div id="changeEmailform">
      <div class="center">
        <label for="changeEmailInput">New Email:</label>
        <input class="bottom7" type="email" id="changeEmailInput" autocomplete="email">
        <div class="inputMessages center" id="changeEmailMessage"></div>
      </div>
      <div class="center">
        <label for="changeEmailPasswordInput">Current Password:${currentPasswordSplainerHTML("changeEmailPasswordSplainer")}</label>
        <input class="bottom7" type="password" id="changeEmailPasswordInput" autocomplete="current-password">
      </div>
      <div class="center">
        <button 
          type="submit" 
          id="changeEmailSubmit" 
          class="submitButton bottom7 button workADayButtons">
          Submit
        </button>
        <div class="inputMessages center" id="changeEmailSubmitMessage"></div>
      </div>
    </div>
    <br>
  `;

  dasModal.render(html);
  const changeEmailInput = document.getElementById("changeEmailInput");
  changeEmailInput.style.backgroundColor = colors.getGameColor("lighterAccent");
  document.getElementById("changeEmailPasswordInput").style.backgroundColor =
    colors.getGameColor("lighterAccent");
  changeEmailInput.focus();

  // Now fill in the current email (textContent: it's user-entered text)
  const accountResult = await identityService.getMyAccount();
  fillLoadedText(
    "currentEmail",
    accountResult.status === 200
      ? accountResult.account.email
      : accountResult.message || "Unable to load",
  );
};

const handleChangeEmailSubmit = async () => {
  const email = document.getElementById("changeEmailInput").value;
  const currentPassword = document.getElementById(
    "changeEmailPasswordInput",
  ).value;
  const messageElement = document.getElementById("changeEmailSubmitMessage");
  const changeEmailSubmit = document.getElementById("changeEmailSubmit");
  if (currentPassword.length === 0) {
    messageElement.innerText = "Please enter your current password";
    return;
  }
  changeEmailSubmit.disabled = true;
  changeEmailSubmit.style.cursor = "wait";
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  messageElement.innerText = "Submitting...";

  // setEmail validates the format and checks the email isn't taken
  const result = await identityService.setEmail(email, currentPassword);
  messageElement.innerText = "";
  document.body.style.cursor = "default";
  changeEmailSubmit.style.cursor = "default";
  changeEmailSubmit.disabled = false;
  if (result.status != 200) {
    messageElement.innerText = result.message || "Error: Unable to change the email";
    return;
  }
  dasModal.close();
  profile.render("small");
  dasModal.render(
    `<div class="max">The email has been updated. Please verify the new email.</div>`,
  );
};

const handleChangeEmailKeyUp = (event) => {
  event.stopPropagation();
  const email = document.getElementById("changeEmailInput").value;
  const messageElement = document.getElementById("changeEmailMessage");
  const result = identityService.isEmailValid(email);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

eventHub.registerEvent("click", "changeEmailSubmit", handleChangeEmailSubmit);
eventHub.registerEvent("keyup", "changeEmailInput", handleChangeEmailKeyUp);
eventHub.registerEvent(
  "click",
  "changeEmailPasswordSplainer",
  renderCurrentPasswordSplainer,
);

export const changeEmailPop = {
  render,
};
